import { render, staticRenderFns } from "./HomeTab2.vue?vue&type=template&id=cc83dc14&scoped=true"
import script from "./HomeTab2.vue?vue&type=script&lang=js"
export * from "./HomeTab2.vue?vue&type=script&lang=js"
import style0 from "./HomeTab2.vue?vue&type=style&index=0&id=cc83dc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc83dc14",
  null
  
)

export default component.exports